import { Module } from '@nestjs/common';
import { StorefrontTemplatesController } from './storefront-templates.controller';
import { StorefrontTemplatesService } from './storefront-templates.service';
import { TenancyModule } from '../tenancy/tenancy.module';
import { AuthModule } from '../auth/auth.module';

// Storefront layout templates. Not TemplatesModule — that is email.
@Module({
  imports: [TenancyModule, AuthModule],
  controllers: [StorefrontTemplatesController],
  providers: [StorefrontTemplatesService],
  exports: [StorefrontTemplatesService],
})
export class StorefrontTemplatesModule {}
